import { QrScanner } from '@yudiel/react-qr-scanner';
import { Drawer } from 'antd';
import { useRef, useState } from 'react';
import { Location, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { Icon } from '../../assets/icon';
import { Button, Paragraph } from '../../fields';
import { useAppDispatch } from '../../hooks/hook-store';
import { Box, Separator } from '../../utils';
import { asyncUpdateBarcode } from './store/scanner.slice';
import { BackButton, ScannerContainer } from './styles';

export const scannerFormats: any[] = [
    'qr_code',
    'itf',
    'ean_8',
    'ean_13',
    'codabar',
    'code_93',
    'code_39',
    'code_128',
    'upc_a',
    'upc_e',
];

function useSize() {
    let width = window.innerWidth;
    let height = window.innerHeight;
    if (width < height) {
        return {
            width,
            height: width
        };
    } else {
        return {
            width: height,
            height
        };
    }
}

export const ScannerPage = () => {
    const dispatch = useAppDispatch();
    const location: Location = useLocation();
    const { state } = location as Location & { state: { pathFrom: string, ID_Shift: string } };
    const navigate = useNavigate();

    const [open, setOpen] = useState<boolean>(false);
    const isNavigatingRef = useRef<boolean>(false);

    const extractBarcodeValue = (payload: any): string => {
        if (!payload) return '';
        if (typeof payload === 'string') return payload.trim();
        if (Array.isArray(payload)) {
            const first = payload[0];
            if (!first) return '';
            if (typeof first === 'string') return first.trim();
            return String(first.rawValue ?? first.value ?? first.data ?? '').trim();
        }
        return String(payload.rawValue ?? payload.value ?? payload.data ?? '').trim();
    };

    const handleOnScan = (payload: any) => {
        const normalizedBarcode = extractBarcodeValue(payload);
        console.log('[Scanner] decode payload:', payload);
        console.log('[Scanner] normalized barcode:', normalizedBarcode);
        if (isNavigatingRef.current) return;
        if (normalizedBarcode?.length > 0) {
            isNavigatingRef.current = true;
            dispatch(asyncUpdateBarcode({ barcode: normalizedBarcode, ID_Shift: state?.ID_Shift }))
                .then(() => {
                    navigate(`${state.pathFrom}`);
                });
        }
    };

    const handleScanError = (error: unknown) => {
        console.log('[Scanner] error payload:', error);
        const message = String((error as any)?.message ?? '');
        const name = String((error as any)?.name ?? '');
        const isPermissionError = /NotAllowedError|Permission|denied|permission/i.test(`${name} ${message}`);

        if (isPermissionError) {
            setOpen(true);
        }
    };

    const scannerProps: any = {
        constraints: { facingMode: 'environment' },
        onDecode: handleOnScan,
        onScan: handleOnScan,
        onError: handleScanError
    };
    return (
        <>
            <ScannerContainer
                {...useSize()}
            >
                <QrScanner {...scannerProps} />
            </ScannerContainer>
            <BackButton onClick={() => navigate(-1)}>
                <Icon type={'back'} width={20} height={20} color={'#000000'} />
            </BackButton>
            <Drawer
                title="Доступ к камере отклонен."
                placement={'bottom'}
                closable={false}
                height={250}
                onClose={() => setOpen(false)}
                open={open}
                key={'bottom'}
            >
                <Box>
                    <Paragraph as={'p'} weight={'400'} colorType={'main'} fontSize={16}>
                        Пожалуйста предоставьте доступ.
                    </Paragraph>
                    <Separator space={10} />
                    <ConfirmBtn full={true}>Предоставить</ConfirmBtn>
                </Box>
            </Drawer>
        </>
    );
};


const ConfirmBtn = styled(Button)`
  background-color: var(--error-color);
  border-color: var(--error-color);
  color: #FFFFFF;
`;
